import api from "../helpers/axios";

class UserService {

    async getAllUsers(queryParams = "") {
        try {
            const response = await api.get(`/users/v2${queryParams}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching user:`, error);
            throw error;
        }
    }

    async addUser(payload) {
        try {
            const response = await api.post(`/users/add`, payload);
            return response.data;
        } catch (error) {
            console.error(`Error adding user:`, error);
            throw error;
        }
    }

    // Sends a fresh invite to an email so the person can set up their own account.
    async inviteUser(payload) {
        try {
            const response = await api.post(`/users/invite`, payload);
            return response.data;
        } catch (error) {
            console.error(`Error inviting user:`, error);
            throw error;
        }
    }

    // Re-sends the invite to a user who hasn't finished setting up yet.
    async resendInvite(email) {
        try {
            const response = await api.post(`/users/resend-invite`, { user_email: email });
            return response.data;
        } catch (error) {
            console.error(`Error resending invite:`, error);
            throw error;
        }
    }

    // Returns the distinct org_department values for a facility as a string array.
    // facility_id is optional (admins are locked to their own facility by the backend).
    async getDepartments(facilityId) {
        try {
            const query = facilityId ? `?facility_id=${facilityId}` : "";
            const response = await api.get(`/users/org-departments${query}`);
            return response.data?.org_departments || [];
        } catch (error) {
            console.error(`Error fetching departments:`, error);
            throw error;
        }
    }

}
export default new UserService();